import { hasLength } from "@-/com.npmjs.ts-array-length";

function isCoordinatePair(value: unknown): value is [number, number] {
  if (!Array.isArray(value) || !hasLength(value, 2)) {
    return false;
  }
  const [a, b] = value;
  return typeof a === "number" && typeof b === "number" && Number.isFinite(a) && Number.isFinite(b);
}

/** Normalizes one Hanzi Writer `medians[i]` polyline into integer `[x, y]` tuples. */
export function parseStrokeMedianPolyline(value: unknown): [number, number][] {
  if (!Array.isArray(value)) {
    return [];
  }
  const result: [number, number][] = [];
  for (const point of value) {
    if (isCoordinatePair(point)) {
      result.push([Math.round(point[0]), Math.round(point[1])]);
    }
  }
  return result;
}
